import './styles/tailwind.css';
import './styles/index.scss';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { consumeFormSubmittedForBfcacheReloadFlag } from '../../shared/utils';

export function renderRoot() {
  const elementById =
    document.getElementById('tax-root') || document.getElementById('root');
  if (!elementById) {
    console.error("Element with ID 'tax-root' or 'root' not found.");
    return;
  }
  const root = createRoot(elementById);
  root.render(<App />);
}

// A bfcache restore after a successful submission resumes stale frozen state and risks a
// duplicate referral. Only that case reloads; restores of an unsubmitted form are left alone.
export function initBfcacheReload() {
  window.addEventListener('pageshow', (event) => {
    // Consume on every pageshow so a stale flag can't trigger a later, unrelated reload.
    const wasSubmittedBeforeFreeze = consumeFormSubmittedForBfcacheReloadFlag();
    if (event.persisted && wasSubmittedBeforeFreeze) {
      window.location.reload();
    }
  });
}

initBfcacheReload();
renderRoot();
